import TtamAdListHeader from './header/index.vue';
import TtamAdListButtons from './buttons/index.vue';
import TtamAdListItem from './list-item/index.vue';
import TtamAdListEachItemTips from './list-item/item-tips.vue';
import TtamAdListEachItemButtons from './list-item/item-operate-buttons.vue';
import TtamAdListUpdateMaterualName from './update-material-name/index';

import * as hooks from './hooks';

export default {
  ...hooks,
  TtamAdListHeader,
  TtamAdListButtons,
  TtamAdListItem,
  TtamAdListEachItemTips,
  TtamAdListEachItemButtons,
  TtamAdListUpdateMaterualName,
};
